import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 2,
  class: "px-3 pb-3"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-center gap-2 px-3 mt-1" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-xs font-medium uppercase tracking-wide text-gray-400" }, "Transporte"),
  /*#__PURE__*/_createElementVNode("span", { class: "flex-1 border-t border-gray-200" })
], -1)
const _hoisted_4 = {
  key: 0,
  class: "flex flex-col"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-center gap-2 px-3 mt-1" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-xs font-medium uppercase tracking-wide text-gray-400" }, "Motorista"),
  /*#__PURE__*/_createElementVNode("span", { class: "flex-1 border-t border-gray-200" })
], -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-center gap-2 px-3 mt-1" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-xs font-medium uppercase tracking-wide text-gray-400" }, "Produto"),
  /*#__PURE__*/_createElementVNode("span", { class: "flex-1 border-t border-gray-200" })
], -1)
const _hoisted_7 = {
  key: 8,
  class: "p-3"
}

import store from "@/store";
import { ref, inject, onMounted, computed } from "vue";
import InputText from "../inputs/InputText.vue";
import InputArray from "../inputs/InputArray.vue";
import SelectInput from "../inputs/SelectInput.vue";
import InformacoesMotorista from "./InformacoesMotorista.vue";
import helpers from "@/helpers";
import Bobjeto from "../inputs/Bobjeto.vue";
import { FormValidatedValuesKey } from "../../types/inject";
import ProdutosASeremDescarregados from "./ProdutosASeremDescarregados.vue";
import NotasPallet from "./NotasPallet.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'Informacoes',
  setup(__props) {

const values = inject(FormValidatedValuesKey, {});

const showForm = ref(false);
onMounted(async () => {
  store.dispatch("resetLoader");
  await store.dispatch("buscaDdis");
  await store.dispatch("getSetores");
  await store.dispatch("getVeiculos");

  showForm.value = true;
});

const usuario_externo = computed(() => store.state.acessos.usuario_externo);


const ddis = computed(() => store.state?.ddis ?? []);

const array_tipo_veiculo = computed(
  () => (store.state.arr["array_tipo_veiculo"]?.valores ?? []).filter((veiculo) => !! veiculo.name)
);
const array_setor = computed(() => {
  if (usuario_externo.value) {
    return (store.state.arr["array_setor"]?.valores ?? []).filter((setor) => ! setor.name.includes('EXPEDIÇÃO'))
  }

  return store.state.arr["array_setor"]?.valores ?? [];
});

const setorAlmoxarifado = computed(
  () => values?.setor == array_setor.value.find((i) => i.name == 'ALMOXARIFADO')?.value
);

const setorNaoConforme = computed(
  () => values?.setor == array_setor.value.find((i) => i.name == 'NÃO CONFORME')?.value
);

return (_ctx: any,_cache: any) => {
  return (showForm.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_unref(values).operacao == 2 && ! _unref(setorAlmoxarifado))
          ? (_openBlock(), _createBlock(InputText, {
              key: 0,
              label: "Tipo do produto a ser descarregado",
              name: "tipo_produto_a_ser_descarregado",
              tclass: "w-full"
            }))
          : _createCommentVNode("", true),
        (_unref(values).operacao == 2 && _unref(setorAlmoxarifado))
          ? (_openBlock(), _createBlock(SelectInput, {
              key: 1,
              items: [
        {
          name: 'Selecione...',
          value: ''
        },
        {
          name: 'Insumos/Embalagens',
          value: 'Insumos/Embalagens'
        },
        {
          name: 'Pallets',
          value: 'Pallets'
        },
        {
          name: 'Componentes em geral',
          value: 'Componentes em geral'
        }
      ],
              name: "tipo_produto_a_ser_descarregado",
              tclass: "w-full",
              label: "Tipo do produto a ser descarregado"
            }, null, 8, ["items"]))
          : _createCommentVNode("", true),
        (_unref(values).operacao == 2 && _unref(values).tipo_produto_a_ser_descarregado == 'Pallets')
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(NotasPallet)
            ]))
          : _createCommentVNode("", true),
        _createVNode(InputArray, {
          name: "tipo_carga",
          tclass: "w-full",
          label: "Carga",
          arrayName: "tipo_carga",
          excludeItens: [1, 7]
        }),
        _hoisted_3,
        (!_unref(usuario_externo))
          ? (_openBlock(), _createBlock(InputText, {
              key: 3,
              name: "transportadora",
              tclass: "w-full",
              label: "Transportadora"
            }))
          : _createCommentVNode("", true),
        (_unref(usuario_externo))
          ? (_openBlock(), _createBlock(InputText, {
              key: 4,
              name: "placa",
              tclass: "w-full",
              label: "Placa",
              maxlength: "7",
              placeholder: "AAA-9A99"
            }))
          : (_openBlock(), _createBlock(Bobjeto, {
              key: 5,
              name: "ff08_ukey",
              name_term: "placa",
              label: "Placa",
              maxlength: "7",
              searchIn: [
          {
            campo: 'placa',
            suffix: '%',
          },
        ],
              objeto: "veiculo",
              tclass: "w-full"
            }, {
              exibicao: _withCtx(({ item }: any) => [
                item
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                      _createElementVNode("p", null, _toDisplayString(_unref(helpers).formatPlacaVeiculo(item.placa)), 1)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })),
        _createVNode(SelectInput, {
          name: "veiculo",
          tclass: "w-full",
          label: "Veículo",
          items: _unref(array_tipo_veiculo)
        }, null, 8, ["items"]),
        _hoisted_5,
        _createVNode(InformacoesMotorista),
        (_unref(values).ddi)
          ? (_openBlock(), _createBlock(SelectInput, {
              key: 6,
              items: _unref(ddis),
              name: "ddi",
              tclass: "w-full",
              label: "País do Celular (DDI)"
            }, null, 8, ["items"]))
          : _createCommentVNode("", true),
        _createVNode(InputText, {
          label: `Celular ${_unref(values).ddi ? `+${_unref(ddis).find((i) => i.value == _unref(values).ddi)?.ddi} ${_unref(values).celular}` : ''}`,
          name: "celular",
          mascara: _unref(values).ddi ? '000000000000' : '(00) 00000-0000',
          tclass: "w-full",
          placeholder: "(99) 99999-9999"
        }, null, 8, ["label", "mascara"]),
        _hoisted_6,
        _createVNode(InputText, {
          type: "textarea",
          placeholder: "INFORMAR N° DAS NOTAS FISCAIS QUE SERÃO ENTREGUES",
          rows: 3,
          maxlength: "240",
          name: "observacoes",
          tclass: "w-full",
          label: "Informações adicionais"
        }),
        (_unref(values).operacao == 2 && _unref(setorNaoConforme))
          ? (_openBlock(), _createBlock(SelectInput, {
              key: 7,
              items: [
        {
          name: 'Selecione...',
          value: ''
        },
        {
          name: 'Em bom estado',
          value: 'Em bom estado'
        },
        {
          name: 'Produtos avariados',
          value: 'Produtos avariados'
        },
        {
          name: 'Produtos com caruncho',
          value: 'Produtos com caruncho'
        }
      ],
              name: "estado_produto_a_ser_descarregado",
              tclass: "w-full",
              label: "Estado do produto a ser descarregado"
            }, null, 8, ["items"]))
          : _createCommentVNode("", true),
        (_unref(values).operacao == 2 && _unref(setorAlmoxarifado) && _unref(values).tipo_produto_a_ser_descarregado == 'Insumos/Embalagens')
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createVNode(ProdutosASeremDescarregados)
            ]))
          : _createCommentVNode("", true),
        _createVNode(InputText, {
          label: "Peso bruto (kg)",
          name: "peso_bruto",
          tclass: "w-full",
          type: "number"
        })
      ]))
    : _createCommentVNode("", true)
}
}

})